// extracted by mini-css-extract-plugin
export default {"phone":"appPreview_phone__oozvV","notch":"appPreview_notch__p+hyw","screen":"appPreview_screen__xh88M","shot":"appPreview_shot__y3HoA","shotActive":"appPreview_shotActive__NxZEL"};